import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    card: {
      borderTop: `1px solid ${theme.colors.neutral[1]}`,
    },
  }
})
